import axios from "./axios_auth_less";
import Base from "./Base";
import ArticleResponseMaker from "./HomePageContentAPICall/articleResponseMaker";
import VideoResponseMaker from "./HomePageContentAPICall/videoResponseMaker";
import ResponseMaker from "./HomePageContentAPICall/responseMaker";
import HomePage from "@system/config/home-page";
import System from "src/helper/system";
import allContentCountResponseMaker from "./HomePageContentAPICall/allContentCountResponseMaker"
import allTabsCountResponseMaker from "./HomePageContentAPICall/allTabsCountResponseMaker";
import { isArray } from "underscore";
import HomePageDocumentContentAPICall from "./HomePageDocumentContentAPICall";
import ProductListingAPICall from "./ProductListingAPICall";
import Product from "@system/config/product";
import Helper from "src/support/Helper";

const speedBoat = (System.auth('speedBoat') === 'T' ? 'Abacus' : System.auth('speedBoat') === 'B' ? 'EBV' : 'Silica')

class HomePageContentAPICall extends Base {
    getAllTabsCount = async (params) => {
        let res = {
            data: {}
        };
        // OneSite count was deleted
        
        if (params.currentTab !== "DCT") {
            let resFromDoc = await new HomePageDocumentContentAPICall().getDocumentListCount(params.searchParam);
            res.data.docCount = resFromDoc.data.count;
        }
        res.data.contentCount = 0;
        res.data.npiCount = 0;
        // Hide Content Tab
        if (params.currentTab !== "CNT") {
            let resFromContent = await new HomePageContentAPICall().getContentTabCount(params);
            res.data.contentCount = resFromContent.data.contentTabCount.allCount;
        }
        if (params.currentTab !== "NPIT") {
            let respNPI = await new HomePageContentAPICall().getNPIListBySearchParam(1, 10000, '', params.searchParam);            // for static page 1 to 10K is passed
            if (respNPI && respNPI.data && respNPI.data.npiContentList && respNPI.data.npiContentList.length > 0) {
                res.data.npiCount = respNPI.data.totalContentList;
            }
        }

        if (params.currentTab === "NPIT" || params.currentTab === "CNT" || params.currentTab === "DCT") {
            let resProduct = await new ProductListingAPICall().getList(0, 0, {
                isSkipFacets: true,
                search: params.searchParam,
                skipURLParams: true,
                // universalSearch: universalSearch
            }, false);
            res.data.productListingCount = resProduct['@odata.count'];
        }

        let result = await new allTabsCountResponseMaker(res);
        result = await result.process();
        return result.run().get();
    };
    getAllContentList = async (params) => {
        let param = {
            pageSize: params.limit,
            pageNumber: params.page,
            searchTerm: params.searchParam,
            // pageType: 'All',
            // wt: HomePage.browse_tabs_param('wt'),
            // avnAssetSortOption: 'name_ntk_cs',
            orderBy: params.sort,
            contentType: 'All'

        };

        let res = {};
        await this.axiosCall(HomePage.BROWSE_TABS_CONTENT_NEW, {
            ...param
        }, 'GET').then(function (response) {
            res.data = {};
            res.data['allContentList'] = response.data
        }).catch(e => {
            res.data = {};
        });
        // return await new ResponseMaker(res).process().run().get()
        let result = await new ResponseMaker(res);
        result = await result.process()
        return result.run().get()
    };
    getArticleContentList = async (params) => {
        let param = {
            pageSize: params.limit,
            pageNumber: params.page,
            searchTerm: params.searchParam,
            contentType: 'article',
            avnAssetSortOption: 'name_ntk_cs' // Articles
        };

        if (params.sort !== '') {
            param.orderBy = params.sort
        }
        param.filterBy = []
        if (params.filterList.length > 0) {
            params.filterList.map((v, i) => (
                param.filterBy.push(v.filterName)
            ))
        }

        let res = {};
        await this.axiosCall(HomePage.BROWSE_TABS_CONTENT_NEW, {
            ...param
        }, 'GET').then(function (response) {
            res.data = {};
            res.data['articleContentList'] = response.data
        }).catch(e => {
            res.data = {};
        });
        let result = await new ArticleResponseMaker(res);
        result = await result.process()
        return result.run().get()
    };

    getVideosList = async (params) => {
        let param = {
            pageSize: params.limit,
            pageNumber: params.page,
            searchTerm: params.searchParam,
            pageType: 'Video',
            mediatype: 'video',
            profileName: HomePage.browse_tabs_param('profileVideo')
        };

        if (params.sort !== '') {
            param.avnAssetSortOption = 'name_ntk_cs'
            param.orderBy = params.sort
        }
        param.filterBy = []
        if (params.filterList.length > 0) {
            params.filterList.map((v, i) => (
                param.filterBy.push(v.filterName)
            ))
        }

        let res = {};
        await this.axiosCall(HomePage.BROWSE_TABS_CONTENT, {
            ...param
        }, 'GET', false, false, true, false, true).then(function (response) {
            res.data = {};
            res.data['videoContentList'] = response.data
        }).catch(e => {
            res.data = {};
        });
        let result = await new VideoResponseMaker(res);
        result = await result.process();
        return result.run().get();
    };


    getSitePagesContentList = async (page = 1, limit = 10, sort = '', searchParam) => {
        let res = {};
        await this.axiosCall(HomePage.BROWSE_TABS_CONTENT_NEW, {
            pageSize: limit,
            pageNumber: page,
            searchTerm: searchParam,
            // '_wcf.search.expr': searchParam,
            // pageType: 'SitePage',
            contentType: 'other',
            avnAssetSortOption: 'name_ntk_cs',
            orderBy: sort
        }).then(function (response) {
            res.data = {};
            res.data['sitePageContentList'] = response.data
        }).catch(e => {
            res.data = {};
        });
        let result = await new ResponseMaker(res);
        result = await result.process();
        return result.run().get();
    };

    getEventsList = async (page = 1, limit = 10, orderBy = '', searchParam) => {
        let res = {};
        await this.axiosCall(HomePage.BROWSE_TABS_CONTENT_NEW, {
            pageSize: limit,
            pageNumber: page,
            searchTerm: searchParam,
            '_wcf.search.expr': searchParam,
            contentType: 'event',
            avnAssetSortOption: 'name_ntk_cs',
            orderBy
        }).then(function (response) {
            res.data = {};
            res.data['eventContentList'] = response.data
        }).catch(e => {
            res.data = {};
        });
        let result = await new ResponseMaker(res);
        result = await result.process();
        return result.run().get();
    };

    getContentTabCount = async (params) => {
        let param = {
            searchTerm: params.searchParam,
        };
        let res = {
            data: {}
        };
        /* by Hardik Sarodiya
              * Hide NPI and Content tab
              * Ticket No: 11999
              */
        await this.axiosCall(HomePage.CONTENT_TAB_COUNT_NEW, {
            ...param
        }, 'GET', false, false, false, false, true, true).then(function (response) {
            res.data = response.data;
        });
        let result = await new allContentCountResponseMaker(res);
        result = await result.process();
        return result.run().get();
    };
    getAllContentVideoList = async (params) => {
        let param = {
            // searchType: 102,
            pageSize: params.limit,
            pageNumber: params.page,
            searchTerm: params.searchParam,
            // pageType: params.pageType && params.pageType.trim()!==''  ? params.pageType : 'Video',
            mediatype: 'video',
            contentType: 'other'
        };

        let res = {};
        await this.axiosCall(HomePage.BROWSE_TABS_CONTENT, {
            ...param
        }, 'GET', false, false, true, false, true).then(function (response) {
            res.data = {};
            res.data['allContentVideoList'] = response.data
        }).catch(e => {
            res.data = {};
        });
        //return await new ResponseMaker(res).process().run().get()
        let result = await new ResponseMaker(res);
        result = await result.process();
        return result.run().get();
    };

    getNPIListBySearchParam = async (page = 1, limit = 10, orderBy = '', searchParam) => {
        let res = {};
        await this.axiosCall(HomePage.BROWSE_TABS_CONTENT_NEW, {
            pageSize: limit,
            pageNumber: page,
            searchTerm: searchParam,
            // '_wcf.search.expr': searchParam,
            // avnAssetSortOption: 'name_ntk_cs',
            // pageType: 'Events',
            contentType: 'npintro',
            cache: false,
            orderBy,
        }, 'GET').then(function (response) {
            res.data = {}
            res.data['npiContentList'] = response.data
        }).catch(e => {
        });
        let result = await new ResponseMaker(res);
        result = await result.process();
        return result.run().get();
    };

    axiosCall = async (url, data = {}, method = 'get', skipParams = false, isBlob = false, isAllVideo = false, isNPI = false, isOld = false, isAllCount = false) => {
        let params = {
            store: 'emea',
            profileName: 'Avn_fspFindWebContentBySearchTerm',
            // contentType: 'others',
            // currency: window.mct,
            avnAssetSortOption: 'name_ntk_cs',
            // orgEntityId: HomePage.browse_tabs_param('orgEntityId'),
            // contractId: HomePage.browse_tabs_param('contractId'),
            // wt: HomePage.browse_tabs_param('wt'),
            // '_wcf.search.expr': data.searchTerm,
            // userAction: true,
            selectedSpeedBoat: speedBoat,
            ...data
        };

        if (isOld) {
            params = {
                responseFormat: 'json',
                profileName: isAllVideo ? HomePage.browse_tabs_param('profileVideo') : HomePage.browse_tabs_param('profileName'),
                contentType: 'others',
                storeId: HomePage.browse_tabs_param('storeId'),
                catalogId: HomePage.browse_tabs_param('catalogId'),
                langId: HomePage.browse_tabs_param('langId'),
                currency: window.mct,
                orgEntityId: HomePage.browse_tabs_param('orgEntityId'),
                contractId: HomePage.browse_tabs_param('contractId'),
                wt: HomePage.browse_tabs_param('wt'),
                '_wcf.search.expr': data.searchTerm,
                userAction: true,
                selectedSpeedBoat: speedBoat,
                ...data
            };
        }
        // For All Content Count call profile name is not passing 
        if (isAllCount && params['profileName']) {
            delete params['profileName']
        }
        if (isNPI) {
            params['contentType'] = 'npintro';
            params['avnBusinessCategory'] = Product.autosuggest_param('avnBusinessCategory');
            params['profileName'] = Product.autosuggest_param('profileName');
            if (params.pageType !== undefined && params.pageType !== null && params.pageType != '') {
                delete params['pageType'];
            }
        }
        let paramsToSend = $.param(params);
        let filterBy = [];
        if (params.filterBy !== undefined && isArray(params.filterBy) && params.filterBy.length > 0) {
            filterBy = params.filterBy;
            delete params.filterBy;
        }
        /**
         * Ticket #  : 7013
         * Change #  : Add filter params as encoded for article tab
         * Change by : Pankaj
         * Date      : 27 April 2023
         */
        if (filterBy.length > 0) {
            paramsToSend = $.param(params);
            let paramsURLFilterBy = new URLSearchParams();
            filterBy.map((v) => {
                if (params['contentType'] && params['contentType'].toLowerCase() === 'article') {
                    paramsURLFilterBy.append("filterBy", encodeURIComponent(v));
                }
                else {
                    paramsURLFilterBy.append("filterBy", v);
                }
            });

            if (params['contentType'] && params['contentType'].toLowerCase() === 'article') {
                let filterByArr = paramsURLFilterBy.getAll('filterBy');
                let filterString = '';
                if (filterByArr !== null && filterByArr.length > 0) {
                    filterByArr.forEach((item) => {
                        filterString += filterString === '' ? 'filterBy=' + item : '&filterBy=' + item
                    })
                }
                if (filterString !== '') {
                    paramsURLFilterBy = filterString;
                }
            }
            else {
                paramsURLFilterBy = paramsURLFilterBy.toString();
            }
            paramsToSend = paramsToSend + "&" + paramsURLFilterBy;
        }
        let config = {
            method: method,
            url: url + "?" + paramsToSend,
            /* headers: {
                "accept": "application/json, text/javascript, *\/*; q=0.01",
                'Content-Type': 'application/json-patch+json',
                'Authorization': Helper.getAuthorizationToken(),
                'Ocp-Apim-Subscription-Key': Helper.getOcpApimSubscriptionKey()
            }*/
            //headers: Helper.getCommonHeader(method), 
        };
        if (isAllVideo && config['contentType'] !== undefined && config['contentType'] !== null) {
            delete config.params['contentType'];
        }
        return axios(config);
    };
    mergeDataWithBase = async (data) => {
        return {
            ...data
        };
    };
}

export default HomePageContentAPICall;